module.exports = __webpack_public_path__ + "static/media/heart-filled.9aef7893.svg";